import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { reportClientError, isChunkError, maybeReloadForChunk } from "@/lib/report";

// Catch errors that escape React's render tree (async, event handlers, imports).
window.addEventListener("error", (e) => {
  reportClientError({
    kind: "window.onerror",
    name: e.error?.name,
    message: e.message || String(e.error),
    stack: e.error?.stack,
  });
});
window.addEventListener("unhandledrejection", (e) => {
  const r = e.reason;
  if (isChunkError(r) && maybeReloadForChunk()) return;
  reportClientError({
    kind: "unhandledrejection",
    name: r?.name,
    message: r?.message || String(r),
    stack: r?.stack,
  });
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
